import { merge } from 'lodash';

type Config = Readonly<{
  gonfalon: {
    host: string;
  };
  datadog: {
    applicationId?: string;
    clientToken?: string;
    site?: string;
  };
}>;

let config: Config;
let override: Partial<Config> = {};
const local: Config = require('../ticket-review.local.json');

if (process.env.TICKET_REVIEW_MODE === 'production') {
  override = require('../ticket-review.prod.json');
} else if (process.env.TICKET_REVIEW_MODE === 'staging') {
  override = require('../ticket-review.stg.json');
} else {
  try {
    override = require('../ticket-review.override.json');
  } catch {
    override = {};
  }
}

config = merge({}, local, override);

export default config;
